import React from 'react'
import { useSelector } from 'react-redux'

export const CtrlLoader = () => {
    const inicio = useSelector(state => state.inicio)
    const {IsBusy}=inicio
    return (
        <div className={`ctrl-loader${IsBusy?" show":""}`}>
            <div className="ctrl-loader-content">
                <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
            </div>            
        </div>
    )
}
